import React, { useState } from "react";
import { API_MARK_LESSON_AS_COMPLETE_AND_NEXT } from "../../../ApiEndPoints";
import AxiosClient from "../../../client/AxiosClient";
import DismissableAlert from "../../../component/DismissableAlert";

export default function CompleteAndNextLessonBtn({
  currentLessonIds,
  setCurrentLessonIds,
  setReloadCourseContent,
}) {
  const [error, setError] = useState("");
  const markAsCompleted = () => {
    AxiosClient.post(API_MARK_LESSON_AS_COMPLETE_AND_NEXT, {
      course_id: currentLessonIds.courseId,
      lesson_id: currentLessonIds.lessonId,
      chapter_id: currentLessonIds.chapterId,
    })
      .then((response) => {
        const responseData = response.data;

        console.log("complete & next response: ", responseData.data);

        if (responseData.success == false) {
          setError(responseData.message);
        }

        if (responseData?.success == true) {
          setError("");
          setCurrentLessonIds({
            courseId: responseData.data.course_id,
            chapterId: responseData.data.chaper_id,
            lessonId: responseData.data.lessson_id,
          });

          setReloadCourseContent();
        }
      })
      .catch((err) => {
        console.error("Getting error while marking lesson as complete", err);
      });
  };

  return (
    <div className="text-end p-2">
      {error.trim() != "" && (
        <DismissableAlert title="Alert" desc={error} classes="text-start" />
      )}

      <button className="btn btn-primary" onClick={markAsCompleted}>
        Mark as Complete & next
      </button>
    </div>
  );
}
